import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import TotalMovimientoExportadoresView from '../../components/listados/TotalMovimientoExportadoresView'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerMovimientosExportadores } from '../../actions/listados'

function TotalMovimientoExportadores (props) {
  const { obtenerMovimientosExportadores } = props

  useEffect(() => {
    obtenerMovimientosExportadores(new Date(), new Date())
  }, [obtenerMovimientosExportadores])

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerMovimientosExportadores(fechaD, fechaH)
  }

  return (
    <>
      <div className='container-entre-fechas' style={{ margin: '-3% auto 0 auto' }}>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>

      <TotalMovimientoExportadoresView />
    </>
  )
}

const mapActionsToProps = {
  obtenerMovimientosExportadores
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TotalMovimientoExportadores)
